import { isCollectionCartProduct } from "../store/cartSlice";
import { getProductPricing } from "../utils";

export const getCartBundlePricing = (bundle) => {
  const items = Array.isArray(bundle?.items) ? bundle.items : [];
  let originalSubtotal = 0;
  let currentSubtotal = 0;

  items.forEach((item) => {
    const product = item?.product || {};
    const quantity = Number(item?.quantity || 1);

    const pricing = getProductPricing(
      product,
      isCollectionCartProduct(product),
    );

    originalSubtotal += Number(pricing.originalPrice || 0) * quantity;
    currentSubtotal += Number(pricing.discountedPrice || 0) * quantity;
  });

  const discountPercent = Math.min(
    100,
    Math.max(0, Number(bundle?.discountPercent || 0)),
  );

  const bundleDiscount = currentSubtotal * (discountPercent / 100);
  const total = Math.max(currentSubtotal - bundleDiscount, 0);

  return {
    originalSubtotal,
    currentSubtotal,
    bundleDiscount,
    total,
    totalSavings: Math.max(originalSubtotal - total, 0),
  };
};
